import { render, staticRenderFns } from "./CommonPost.vue?vue&type=template&id=1d686093&lang=pug&"
import script from "./CommonPost.vue?vue&type=script&lang=ts&"
export * from "./CommonPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports